<script lang="ts" setup>
const colorMode = useColorMode();

function toggle () {
  if ( colorMode.preference === "system" ) {
    if ( colorMode.value === "dark" ) {
      colorMode.preference = "light";
    } else {
      colorMode.preference = "dark";
    }
  } else {
    colorMode.preference = "system";
  }
}
</script>

<template>
  <div class="color-mode-switcher">
    <ClientOnly>
      <a-button
        look="pill"
        :title="`Toggle dark mode (currently ${$colorMode.value === 'dark' ? 'on' : 'off'})`"
        @click="toggle">
        <template v-if="$colorMode.value === 'dark'">
          <a-icon
            icon="fa:light:sun"
            size="lg" />
          Light mode
        </template>
        <template v-else>
          <a-icon
            icon="fa:light:moon"
            size="lg" />
          Dark mode
        </template>
      </a-button>
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped>
.color-mode-switcher {
  display: none;
}
.btn {
  min-width: 140px;
  font-size: 0.8rem;
}

svg {
  display: inline-block;
  margin-right: 5px;
}
</style>
